import { Shadows } from '@mui/material/styles';

// Define your custom shadow values here
const THEME_SHADOWS: Partial<Record<number, string>> = {
  0: 'none',
  1: '0 4px 24px rgba(22, 34, 41, 0.06)',
  2: '0 10px 20px rgba(0, 0, 0, 0.1)',
  3: '0 0 40px rgba(0, 0, 0, 0.1)',
  // You can define more custom shadows if needed up to index 24
};

// Generate a full 25-length array of shadow strings
const shadows: Shadows = Array.from({ length: 25 }, (_, index) => {
  return THEME_SHADOWS[index] ?? 'none';
}) as Shadows;

export default shadows;
